"use client";

import { cn } from "@/lib/utils";
import {
  NavigationMenu,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";
import { forwardRef } from "react";
import { NavUser } from "./nav-user";
import { api } from "@/trpc/react";
import { Button } from "./ui/button";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { FeedbackModal } from "./feedback-modal";
import { useActionQueueContext } from "@/providers/action-queue-provider";

// const components: { title: string; href: string; description: string }[] = [
//   {
//     title: "Dashboard",
//     href: "/",
//     description: "Go back to sprint cycle dashboard.",
//   },
// ];

export function SiteNavigationMenu() {
  const logActivity = useActionQueueContext();
  const { data: matchingAccount } = api.supplierAccountsRouter.get.useQuery();
  const { data: selectedRoleMpid } =
    api.supplierAccountsRouter.getSelectedRoleMpid.useQuery();
  const pathname = usePathname();

  const showChangeMPIDRoleButton =
    !pathname.startsWith("/select-group-role") &&
    !pathname.startsWith("/maintenance");

  return (
    <NavigationMenu>
      <NavigationMenuList>
        {/* <NavigationMenuItem>
          <NavigationMenuTrigger className="text-black">
            Actions
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
              {components.map((component) => (
                <ListItem
                  key={component.title}
                  title={component.title}
                  href={component.href}
                >
                  {component.description}
                </ListItem>
              ))}
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem> */}
        {matchingAccount && selectedRoleMpid ? (
          <>
            <FeedbackModal />
            {showChangeMPIDRoleButton ? (
              <Button asChild>
                <Link
                  href="/select-group-role"
                  onClick={() => {
                    logActivity({
                      action: `site_navigation_menu.change_role_mpid.clicked`,
                      info: "User tried to navigate to mpid/role change",
                      unstructured_json: {},
                    });
                  }}
                >
                  Change MPID/Role
                </Link>
              </Button>
            ) : null}
            <NavUser
              user={{
                company: matchingAccount.supplier_name,
                user_fullname: matchingAccount.full_name,
                avatar: matchingAccount.avatar ?? undefined,
                group_mpid:
                  selectedRoleMpid.role === "SUP"
                    ? matchingAccount.group_mpid
                    : undefined,
                mpid:
                  selectedRoleMpid.role !== "SUP"
                    ? matchingAccount.group_mpid
                    : undefined,
              }}
            />
          </>
        ) : null}
      </NavigationMenuList>
    </NavigationMenu>
  );
}

const ListItem = forwardRef<
  React.ElementRef<"a">,
  React.ComponentPropsWithoutRef<"a">
>(({ className, title, children, ...props }, ref) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <a
          ref={ref}
          className={cn(
            "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
            className,
          )}
          {...props}
        >
          <div className="text-sm font-medium leading-none">{title}</div>
          <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
            {children}
          </p>
        </a>
      </NavigationMenuLink>
    </li>
  );
});
ListItem.displayName = "ListItem";
